import { useIntl } from 'react-intl';

import { FilterTypeLegacy, SubjectVariableTypeLegacy } from '@verantos-dev/types-cohorts';

import { type CohortBuilderEditModalActionButtonProps } from '../../../../../components/CohortBuilderEditModal/CohortBuilderEditModalActions/CohortBuilderEditModalActionButton';
import { getAvailableEventTypes } from '../../../../../utils/getAvailableEventTypes';

export const useSubjectVariableEditCardActions = ({
  type,
  onAddConceptFilterClick,
  onAddNumericFilterClick,
}: {
  type: SubjectVariableTypeLegacy | undefined;
  onAddConceptFilterClick: () => void;
  onAddNumericFilterClick: () => void;
}) => {
  const intl = useIntl();
  const availableTypes = getAvailableEventTypes(type);

  const actions: CohortBuilderEditModalActionButtonProps[] = [];

  if (availableTypes.includes(FilterTypeLegacy.CONCEPT)) {
    actions.push({
      id: 'add-concept-filter',
      displayLabel: intl.formatMessage({
        id: 'projects.cohortBuilderPage.subjectVariablesSection.addConceptFilter',
      }),
      onClick: onAddConceptFilterClick,
      disabled: !type,
    });
  }

  if (availableTypes.includes(FilterTypeLegacy.NUMERIC)) {
    actions.push({
      id: 'add-numeric-filter',
      displayLabel: intl.formatMessage({
        id: 'projects.cohortBuilderPage.subjectVariablesSection.addNumericFilter',
      }),
      onClick: onAddNumericFilterClick,
      disabled: !type,
    });
  }

  return actions;
};
